import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import 'leaflet/dist/leaflet.css'
import './index.css'
import App from './App.tsx'
import { ErrorBoundary, OnboardingProvider } from './components/Common'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary componentName="ELIFLY Inspector">
        <OnboardingProvider>
          <App />
          <Toaster 
            position="top-right" 
            richColors 
            closeButton
            toastOptions={{
              duration: 4000,
              style: {
                fontSize: '14px',
              },
            }}
          />
        </OnboardingProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
)
